import { Copy } from '@ev-tech/ui-core-components/Copy';
import { AiArrowDownGradient } from '@pkgs/components/assets/icons/small/AiArrowDownGradient';
import { AiStarGradient } from '@pkgs/components/assets/icons/small/AiStarGradient';
import { isNonEmptyObject } from '@pkgs/components/utils/searchStateUtils';

import { PreferenceScores } from '../PreferenceScores/PreferenceScores';
import { useSearchResultCardContext } from './SearchResultCardProvider';

import styles from './SearchResultCardPreferences.module.css';

export const SearchResultCardPreferences = () => {
  const { preferences, translationResolver: t, variant } = useSearchResultCardContext();
  if (!isNonEmptyObject(preferences)) return null;

  return (
    <PreferenceScores
      isMapView={variant === 'preview'}
      preferences={preferences}
      trigger={
        <button
          className={styles.preferenceAnchor}
          aria-label={t('search.searchbar.sortBy.preferencesLabel', {
            text: `${preferences.overallLabel.toLowerCase()} ${Math.floor(preferences.overallScore)}`,
          })}
          onClick={(event) => event.stopPropagation()}
        >
          <AiStarGradient />
          <Copy text={`${preferences.overallLabel} (${preferences.overallPercentage})`} size="m" />
          <AiArrowDownGradient className={styles.arrow} />
        </button>
      }
    />
  );
};
